import { useMemo } from 'react';
import upperCase from 'lodash/upperCase';
import { StatusLabelType } from '@sdk/components/ui/StatusLabel';
import { pgettext } from '@sdk/lang/gettext';
import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';

export const useStatusLabelAndType = (
  status: TimesheetStatus,
  isAssignee: boolean,
  isManager: boolean
) =>
  useMemo(() => {
    switch (status) {
      case TimesheetStatus.pending:
        return {
          label: upperCase(pgettext('Timesheet status', 'Pending approval')),
          type: isManager ? StatusLabelType.warning : StatusLabelType.pending,
        };

      case TimesheetStatus.pendingConsent:
        return {
          label: upperCase(pgettext('Timesheet status', 'Pending consent')),
          type: isAssignee ? StatusLabelType.warning : StatusLabelType.pending,
        };

      case TimesheetStatus.approved:
        return {
          label: upperCase(pgettext('Timesheet status', 'Approved')),
          type: StatusLabelType.success,
        };

      default:
        return {
          label: undefined,
        };
    }
  }, [status, isAssignee, isManager]);
